/// <amd-module name="Wit/DeliveryPlans/Common/Interfaces" />

import { IClientWorkItem, IObservableClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";
import { WorkItemTypeColorAndIcon } from "Wit/UI/WorkItemTypeIcon";
import { INamedFieldDataDictionary } from "Wit/WorkItemDataManager/Contracts";
import { WorkItemDependencyData } from "./Client/Contracts/DataProvider";
export interface IIteration {
    id: string;
    name: string;
    path: string;
    startDate: Date;
    endDate: Date;
}

export interface ITeam {
    id: string;
    name: string;
    projectId: string;
    backlog: string;
    backlogName: string;
    isExpanded: boolean;
    iterations: IIteration[];
    orderByField: string;
    rollupWorkItemTypes: string[];
    teamFieldName: string;
    teamFieldDefaultValue: string;
    teamFieldValues: { value: string; includeChildren: boolean }[];
    workItemTypeColorAndIcons: { [type: string]: WorkItemTypeColorAndIcon };
}

export interface IDeliveryPlansWorkItem extends IClientWorkItem {
    /**
     * Returns the StartDate of the item if it is defined, the start date of the item's iteration otherwise.
     */
    startDate: Date;
    /**
     * Returns the TargetDate of the item if it is defined, the end date of the item's iteration otherwise.
     */
    endDate: Date;
    iteration: IIteration;
    /**
     * Indicates that the work item has only had a few fields loaded, and the server will need to be queried
     * to retrieve the rest of the work items fields.
     */
    partial: boolean;
    getIteration(): IIteration | undefined;
    setFieldValues(fields: { [fieldName: string]: unknown }): void;
    /**
     * @deprecated Returns all fields defined for the work item.
     * This data may be out of date if the IWorkItem has been loaded.
     * Need to remove this method.
     */
    getFields(): INamedFieldDataDictionary;
}

export interface IObservableDeliveryPlansWorkItem extends IObservableClientWorkItem<IDeliveryPlansWorkItem> {}

export interface DependencyCardElement {
    workItemId: number;
    source: HTMLElement;
    items: ElementAndDependency[];
}

export interface ElementAndDependency {
    element: HTMLElement;
    dependency: WorkItemDependencyData;
}

export interface CardDimensions {
    width: number;
    height: number;
}
